import { CognitoUserAttributes } from '@akin-home/aws-cognito';
import { CognitoUser } from '@aws-amplify/auth';
import { getCognitoUserAttribute } from './cognitoUserAttributes';

export const isCognitoUserEmailVerified = (user: CognitoUser) => {
  const verified = getCognitoUserAttribute(
    user,
    CognitoUserAttributes.EMAIL_VERIFIED
  );

  return verified === 'true';
};
